import { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Checkbox,
    Button,
    Box,
    FormControlLabel,
    Divider,
    DialogActions,
    TextField,
    Grid
} from '@mui/material';
import { getData, postData, putData } from '../../../services/library';
import moment from 'moment';
import { UrlApi } from '../../../services/apirest';
import { v4 as uuidv4 } from "uuid";
import Notify from '../../Notify';

function ModalObservacionesInternas(props) {
    const [uuidinicial, setUuid] = useState(uuidv4());
    const [observaciones, setObservaciones] = useState([]);
    const [selectedObservaciones, setSelectedObservaciones] = useState([]); // Estado para checkboxes

    const [datosFormulario, setdatosFormulario] = useState({
        observaciones: null,
        usuario: localStorage.getItem('user'),
        activo: 1
    });

    // Validar si uuid_pedido es un string no vacío
    // const hasValidUuid = props.datosPedidos?.uuid_pedido && typeof props.datosPedidos.uuid_pedido === 'string';

    const [datosPedidos, setDatosPedido] = useState({
        ...(props.datosPedidos || {}),
        // Asignar null si uuid_pedido no es un string válido
        uuid_pedido:
          props.datosPedidos?.uuid_pedido &&
          typeof props.datosPedidos.uuid_pedido === 'string' &&
          props.datosPedidos.uuid_pedido.trim() !== '' &&
          props.datosPedidos.uuid_pedido !== 'null'
            ? props.datosPedidos.uuid_pedido
            : null,
      });
      
    //   console.log('Inicialización datosPedidos:', datosPedidos); // Depuración

    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const getObservaciones = () => {
        getData(`/observaciones_pedidos/${datosPedidos.uuid_pedido}`, setObservaciones)
        console.log("vuelvo a obrwnwe");
        
    };

    useEffect(() => {
        getObservaciones()
    }, [datosPedidos]);

    // Manejar la selección/deselección de observaciones
    const handleCheckboxChange = (id) => {
        setSelectedObservaciones((prev) =>
            prev.includes(id) ? prev.filter((selectedId) => selectedId !== id) : [...prev, id]
        );
    };

    // Eliminar observaciones seleccionadas
    const handleEliminarSeleccionadas = async (e) => {
        if (selectedObservaciones.length === 0) return;
        try {
            // console.log('Enviando IDs:', selectedObservaciones); // Depuración
            await putData(e, '/observaciones_pedidos/x/actualizar_lista', selectedObservaciones, setNotificacion);
            setObservaciones((prev) => prev.filter((obs) => !selectedObservaciones.includes(obs.id)));
            getObservaciones()
            setSelectedObservaciones([]);
        } catch (err) {
            console.error('Error actualizando observaciones:', err);
        }
    };

    const handleClose = () => {
        props.setOpen(false);
    };

    const almacenar = (e) => {
        setdatosFormulario({
            ...datosFormulario,
            [e.target.name]: e.target.value,
        });
    };

    const id_pedido = datosPedidos.id_pedido || datosPedidos.idpedido;
    // console.log("id", id_pedido);
    // console.log("dartos", datosPedidos);
    
    
    

    const handleAgregarObservaciones = async (e) => {
        e.preventDefault(); // Prevenir comportamiento por defecto del formulario

        try {
          // Validar datosPedidos
          if (!datosPedidos) {
            throw new Error('Datos del pedido no proporcionados');
          }
      
          // Validar observaciones
          if (!datosFormulario.observaciones) {
            throw new Error('No se proporcionó ninguna observación');
          }
      
          // Obtener identificador del pedido (idpedido o id_pedido)
          const pedidoId = datosPedidos.idpedido || datosPedidos.id_pedido;
          if (!pedidoId) {
            throw new Error('No se encontró un identificador de pedido (idpedido o id_pedido)');
          }
      
        //   console.log('datosPedidos:', datosPedidos); // Depuración
        //   console.log('pedidoId:', pedidoId); // Depuración
      
          // Verificar si uuid_pedido es null, no existe, vacío, o inválido
          let currentUuid = datosPedidos.uuid_pedido;
        //   console.log('Current UUID:', currentUuid, 'Type:', typeof currentUuid);
      
          // Validar UUID: debe ser un string no vacío y no "null"
          const isValidUuid =
            currentUuid &&
            typeof currentUuid === 'string' &&
            currentUuid.trim() !== '' &&
            currentUuid !== 'null';
          if (!isValidUuid) {
            // Generar un nuevo UUID
            const newUuid = uuidv4();
            // console.log('Generando nuevo UUID para el pedido:', newUuid);
      
            // Enviar solicitud para actualizar el pedido
            const updateBody = { uuid_pedido: newUuid };
            // console.log('Enviando PUT:', {
            //   url: `${UrlApi}/pedidos/${pedidoId}`,
            //   body: updateBody,
            // });
      
            const updateResponse = await fetch(`${UrlApi}/pedidos/${pedidoId}`, {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(updateBody),
            });
      
            const updateData = await updateResponse.json();
            // console.log('Respuesta del PUT:', updateData);
      
            if (!updateResponse.ok) {
              throw new Error(
                `Error al actualizar el UUID del pedido: ${updateResponse.status} - ${
                  updateData.message || updateResponse.statusText
                }`
              );
            }
      
            // Actualizar datosPedidos con el nuevo UUID
            setDatosPedido((prev) => ({
              ...prev,
              uuid_pedido: newUuid,
            }));
            currentUuid = newUuid;
          } else {
            // console.log('UUID válido, no se ejecuta el PUT:', currentUuid);
            // 
          }
      
          // Enviar observación con postData
          const postBody = {
            observaciones: datosFormulario.observaciones,
            usuario: localStorage.getItem('user'),
            activo: 1,
            uuid_pedido: currentUuid,
          };
        //   console.log('Enviando POST:', postBody);
      
          await postData(
            e,
            `/observaciones_pedidos/`,
            postBody,
            setNotificacion
          );
        } catch (error) {
          console.error('Error al guardar observación:', error);
          
        }
        almacenar({ target: { name: 'observaciones', value: '' } })
        getObservaciones()
    };

    return (
        <div>
            <Dialog open={props.open} onClose={handleClose} fullWidth>
                {notificacion && notificacion.open ? (
                    <Notify
                        mensaje={notificacion.mensaje}
                        open={notificacion.open}
                        color={notificacion.color}
                        handleClose={getObservaciones}
                        severity={notificacion.severity}
                    />
                ) : null}
                <DialogTitle>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Observaciones
                    </Typography>
                </DialogTitle>
                <DialogContent>

                    {observaciones.length > 0 ? (
                        observaciones.map((o) => (
                            <FormControlLabel
                                key={o.id}
                                control={
                                    <Checkbox
                                        checked={selectedObservaciones.includes(o.id)}
                                        onChange={() => handleCheckboxChange(o.id)}
                                    />
                                }
                                label={`${o.observaciones} (${moment(o.created_at).format("DD-MM-YYYY")})`}
                                sx={{ display: 'block', mb: 1 }}
                            />
                        ))
                    ) : (
                        <Typography>No hay observaciones disponibles</Typography>
                    )}
                    <Divider />
                    <Grid container mt={1}>
                        <p>Agregar nuevas observaciones</p>
                        <Grid item xs={12}>
                            <TextField
                                value={datosFormulario.observaciones}
                                name="observaciones"
                                focused
                                color='primary'
                                required
                                onChange={almacenar}
                                fullWidth
                                label="Observaciones internas">
                            </TextField>
                        </Grid>
                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Box sx={{ mb: 2 }}>
                        {
                            selectedObservaciones.length ?
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={handleEliminarSeleccionadas}
                                // disabled={}
                                >
                                    Eliminar Seleccionadas
                                </Button>
                                : null
                        }
                        <Button
                            variant="contained"
                            color="success"
                            onClick={handleAgregarObservaciones}
                            disabled={!datosFormulario.observaciones}
                        >
                            Guardar nuevas observaciones
                        </Button>

                    </Box>
                </DialogActions>

            </Dialog>
        </div>
    );
}

export default ModalObservacionesInternas;